var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsPsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3449 6.41895H5.86499C3.17734 6.41895 1 8.60245 1 11.2977C1 13.993 3.17734 16.1765 5.86499 16.1765H8.88718",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1976 6.4474C18.1976 3.43939 15.7651 1 12.7656 1C9.76605 1 7.33356 3.43939 7.33356 6.4474V8.10777",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1125 5.57166C19.6095 5.57166 20.8229 6.78851 20.8229 8.28967V9.69416",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8228 9.2052H21.1857C23.1079 9.2052 24.6615 10.7689 24.6615 12.6908C24.6615 14.6128 23.1022 16.1765 21.1857 16.1765H19.0934",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9208 16.1823H17.7157",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2573 10.7917C12.0183 10.7917 12.6351 10.1731 12.6351 9.40995C12.6351 8.64683 12.0183 8.0282 11.2573 8.0282C10.4963 8.0282 9.87946 8.64683 9.87946 9.40995C9.87946 10.1731 10.4963 10.7917 11.2573 10.7917Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9207 10.6154V22.2039C11.9207 22.6417 11.5692 22.9942 11.1326 22.9942H7.93463",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5599 10.6097V21.6922H7.94025",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.396 13.8907C19.157 13.8907 19.7739 13.2721 19.7739 12.5089C19.7739 11.7458 19.157 11.1272 18.396 11.1272C17.6351 11.1272 17.0182 11.7458 17.0182 12.5089C17.0182 13.2721 17.6351 13.8907 18.396 13.8907Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7327 13.7201V19.1902C17.7327 19.6281 18.0842 19.9806 18.5208 19.9806H22.8471",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0934 13.7087V18.6728H22.8414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9223 16.1993V22.2097C13.9223 22.6475 14.2739 23.0001 14.7105 23.0001H17.8347",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2888 17.7289V21.6922H17.8347",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04798 16.1993V19.1448C8.04798 19.5826 7.69643 19.9352 7.25983 19.9352H2.33813",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68714 16.1823V18.6273H2.33813",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsPsIcon);
export default __webpack_public_path__ + "static/media/ISPsIcon.8860ede833f47d739264cea784366307.svg";
export { ForwardRef as ReactComponent };